export default function withRootRoute(url: string, rootRoute = '/'): string {
  if (url.startsWith('/') && rootRoute !== '/') {
    return rootRoute + url
  }
  return url
}
